var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPave(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.5592 4.85578V9.01854C8.28332 8.25435 9.85113 7.202 11.2043 5.9233C11.1191 5.72963 11.0037 5.55463 10.8555 5.39946C10.5067 5.03662 10.0284 4.85461 9.41835 4.85461H6.5592V4.85578Z",
    fill: "#6730A0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.04987 9.60187V3.49191H9.50598C10.4835 3.49191 11.2814 3.81625 11.9009 4.46493C12.0233 4.59326 12.133 4.72627 12.231 4.86627C13.3438 3.60974 14.2677 2.18171 14.9595 0.628847C14.4754 0.235672 13.8583 0 13.1864 0H2.81365C1.25984 0 0 1.26003 0 2.81406V10.4267C1.76261 10.4139 3.4599 10.1257 5.04987 9.60187Z",
    fill: "#6730A0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.55935 10.6169V13.6526H5.04987V11.1454C3.44824 11.6261 1.75328 11.8874 0 11.8968V13.186C0 14.74 1.25984 16 2.81365 16H13.1864C14.7402 16 16 14.74 16 13.186V2.81173C16 2.55622 15.965 2.30888 15.9009 2.07321C13.9329 5.93379 10.6083 8.99403 6.55935 10.6169Z",
    fill: "#6730A0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPave);
export default __webpack_public_path__ + "static/media/PAVE.5b3759480e29217554d79c085b423d76.svg";
export { ForwardRef as ReactComponent };